// src/navigation/wrappers/ReaderNavigationWrapper.jsx
import React from 'react';
import ReaderNav from '../../components/ReaderNav';
import ReaderTopMenuBar from '../../components/ReaderTopMenuBar';
import ReaderMobileBottomNav from '../../components/ReaderMobileBottomNav';
import UniversalFooter from '../../components/UniversalFooter';

const ReaderNavigationWrapper = ({ children }) => {
  return (
    <>
      <ReaderNav />
      <ReaderTopMenuBar />
      {children}
      <ReaderMobileBottomNav />
      <UniversalFooter />
    </>
  );
};

export default ReaderNavigationWrapper;
